export const products = [
  {
    id: 1,
    name: '黄油小熊经典毛绒玩偶',
    slug: 'classic-plush-doll',
    category: 'plush',
    price: '¥169',
    description: '30cm经典款黄油小熊毛绒玩偶，采用高品质短毛绒面料，填充饱满柔软，手感细腻顺滑。小熊憨态可掬的表情搭配招牌黄油色外观，是每一位粉丝的必入之选。无论是办公桌陪伴还是床头守护，都能带来满满的治愈感。',
    image: 'https://readdy.ai/api/search-image?query=A%20super%20cute%20warm%20yellow%20cartoon%20butter%20bear%20plush%20toy%20with%20soft%20fluffy%20texture%2C%20sitting%20pose%20with%20tiny%20round%20paws%2C%20adorable%20expression%2C%20simple%20cream%20studio%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%2C%20high%20detail%2C%20clean%20minimal%20composition%2C%20kawaii%20style&width=800&height=800&seq=product-plush-01&orientation=squarish',
    tags: ['热销', '经典款'],
    isNew: false,
    isHot: true,
  },
  {
    id: 2,
    name: '黄油小熊迷你钥匙扣',
    slug: 'mini-keychain',
    category: 'accessories',
    price: '¥49',
    description: '精致迷你的黄油小熊钥匙扣，采用优质亚克力材质，双面印刷图案清晰不掉色。小巧可爱的尺寸适合挂在包包、钥匙或手机上，随时随地都有小熊陪伴。多种表情可选，收集控必入。',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20cute%20warm%20yellow%20butter%20bear%20acrylic%20keychain%20charm%2C%20detailed%20flat%20illustration%20style%2C%20attached%20to%20a%20minimal%20keyring%2C%20simple%20cream%20studio%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%2C%20macro%20shot%2C%20clean%20minimal%20composition&width=800&height=800&seq=product-keychain-02&orientation=squarish',
    tags: ['新品'],
    isNew: true,
    isHot: false,
  },
  {
    id: 3,
    name: '黄油小熊暖绒抱枕',
    slug: 'warm-cushion',
    category: 'home',
    price: '¥129',
    description: '45cm圆形黄油小熊造型抱枕，表面采用超柔短绒面料，触感如云朵般柔软。内充高弹PP棉，长时间使用不变形。可爱的圆形熊脸设计，既可以当抱枕也可以当靠垫，是沙发上最治愈的存在。',
    image: 'https://readdy.ai/api/search-image?query=A%20round%20cute%20warm%20yellow%20butter%20bear%20face%20cushion%20pillow%2C%20ultra%20soft%20velvet%20fabric%20texture%2C%20adorable%20smiling%20expression%2C%20placed%20on%20a%20cozy%20cream%20sofa%2C%20warm%20natural%20lighting%2C%20product%20photography%2C%20clean%20minimal%20composition%2C%20kawaii%20style&width=800&height=800&seq=product-cushion-03&orientation=squarish',
    tags: ['热销'],
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    name: '黄油小熊联名限定T恤',
    slug: 'collab-tshirt',
    category: 'collab',
    price: '¥199',
    description: '黄油小熊×知名设计师联名限定款T恤，采用240g纯棉面料，亲肤透气不缩水。正面印有独家设计的黄油小熊插画，背面领口处有精致的联名标识。男女同款，多色可选，限量发售。',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20cream%20white%20t-shirt%20with%20a%20cute%20warm%20yellow%20butter%20bear%20illustration%20printed%20on%20the%20chest%2C%20flat%20lay%20photography%20on%20a%20clean%20cream%20surface%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20editorial%20style%2C%20kawaii%20aesthetic&width=800&height=800&seq=product-tshirt-04&orientation=squarish',
    tags: ['联名', '限定'],
    isNew: true,
    isHot: false,
  },
  {
    id: 5,
    name: '黄油小熊治愈手账本',
    slug: 'healing-notebook',
    category: 'stationery',
    price: '¥79',
    description: 'A5尺寸黄油小熊主题手账本，封面采用PU软皮材质，压印小熊图案精致有质感。内页选用100g道林纸，书写顺滑不洇墨，包含月计划、周计划和自由书写页。附赠主题贴纸一张，记录生活中的每一个温暖瞬间。',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20warm%20yellow%20butter%20bear%20themed%20notebook%20journal%20with%20embossed%20bear%20pattern%20on%20cream%20PU%20leather%20cover%2C%20laid%20flat%20on%20a%20clean%20cream%20surface%20with%20a%20pen%20beside%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20minimal%20kawaii%20aesthetic&width=800&height=800&seq=product-notebook-05&orientation=squarish',
    tags: [],
    isNew: false,
    isHot: false,
  },
  {
    id: 6,
    name: '黄油小熊陶瓷马克杯',
    slug: 'ceramic-mug',
    category: 'home',
    price: '¥89',
    description: '400ml大容量黄油小熊陶瓷马克杯，杯身印有精美小熊插画，采用高温烧制工艺，图案经久不褪。杯口圆润光滑，握感舒适。搭配硅胶防滑杯垫，无论是咖啡、奶茶还是温水，都让每一口都充满温暖。',
    image: 'https://readdy.ai/api/search-image?query=A%20cream%20white%20ceramic%20mug%20with%20a%20cute%20warm%20yellow%20butter%20bear%20illustration%20printed%20on%20the%20side%2C%20placed%20on%20a%20wooden%20coaster%2C%20clean%20cream%20studio%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%2C%20minimal%20kawaii%20aesthetic&width=800&height=800&seq=product-mug-06&orientation=squarish',
    tags: [],
    isNew: false,
    isHot: false,
  },
  {
    id: 7,
    name: '黄油小熊限定盲盒系列',
    slug: 'blind-box-series',
    category: 'collectible',
    price: '¥69',
    description: '黄油小熊首套盲盒系列「四季物语」，共6款常规款+1款隐藏款。每款小熊身着不同季节主题服饰，精工细作，细节满满。包装盒也采用精美设计，拆盒仪式感十足。全套收集更有惊喜展示效果。',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20cute%20warm%20yellow%20butter%20bear%20blind%20box%20figures%20in%20different%20seasonal%20outfits%2C%20displayed%20on%20a%20clean%20cream%20shelf%2C%20each%20bear%20with%20unique%20costume%20and%20accessories%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20kawaii%20collector%20style&width=800&height=800&seq=product-blindbox-07&orientation=squarish',
    tags: ['限定', '热销'],
    isNew: true,
    isHot: true,
  },
  {
    id: 8,
    name: '黄油小熊帆布托特包',
    slug: 'canvas-tote-bag',
    category: 'accessories',
    price: '¥139',
    description: '大容量黄油小熊帆布托特包，采用16安厚实纯棉帆布，结实耐用。正面印有黄油小熊大幅插画，背面设有内袋方便收纳小物。可肩背可手提，日常通勤、逛街购物都能轻松驾驭。',
    image: 'https://readdy.ai/api/search-image?query=A%20cream%20canvas%20tote%20bag%20with%20a%20large%20cute%20warm%20yellow%20butter%20bear%20illustration%20printed%20on%20the%20front%2C%20hanging%20on%20a%20minimal%20wooden%20hook%2C%20clean%20cream%20studio%20background%20with%20soft%20warm%20lighting%2C%20product%20photography%2C%20kawaii%20aesthetic&width=800&height=800&seq=product-totebag-08&orientation=squarish',
    tags: [],
    isNew: false,
    isHot: false,
  },
  {
    id: 9,
    name: '黄油小熊桌面小夜灯',
    slug: 'desk-night-light',
    category: 'home',
    price: '¥149',
    description: '黄油小熊造型硅胶小夜灯，拍打切换三档亮度，柔和暖光不刺眼。USB充电设计，充满电可持续使用12小时。软萌的造型搭配温暖的灯光，是睡前最好的陪伴，也是送礼的绝佳选择。',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20warm%20yellow%20butter%20bear%20shaped%20silicone%20night%20lamp%20emitting%20a%20soft%20warm%20glow%2C%20placed%20on%20a%20minimal%20wooden%20bedside%20table%2C%20dim%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20product%20photography%2C%20kawaii%20aesthetic&width=800&height=800&seq=product-light-09&orientation=squarish',
    tags: ['新品'],
    isNew: true,
    isHot: false,
  },
  {
    id: 10,
    name: '黄油小熊手机壳套装',
    slug: 'phone-case-set',
    category: 'accessories',
    price: '¥59',
    description: '黄油小熊主题液态硅胶手机壳，全包边防护，精准孔位。表面手感细腻防滑，内侧植绒保护手机。套装含手机壳+小熊支架+挂绳，可爱实用一步到位。支持iPhone及主流安卓机型。',
    image: 'https://readdy.ai/api/search-image?query=A%20cute%20warm%20yellow%20butter%20bear%20themed%20silicone%20phone%20case%20with%20a%20bear%20ear%20design%20on%20top%2C%20flat%20lay%20on%20a%20clean%20cream%20surface%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20minimal%20kawaii%20aesthetic&width=800&height=800&seq=product-phonecase-10&orientation=squarish',
    tags: [],
    isNew: false,
    isHot: false,
  },
  {
    id: 11,
    name: '黄油小熊限定联名保温杯',
    slug: 'collab-thermos',
    category: 'collab',
    price: '¥259',
    description: '黄油小熊×知名品牌联名保温杯，316不锈钢内胆，12小时保温保冷。杯身印有独家联名插画，杯盖采用小熊耳朵造型设计。500ml黄金容量，无论是办公室还是户外出行都是最佳搭档。',
    image: 'https://readdy.ai/api/search-image?query=A%20cream%20white%20stainless%20steel%20thermos%20bottle%20with%20a%20cute%20warm%20yellow%20butter%20bear%20collaboration%20illustration%2C%20bear%20ear%20shaped%20cap%20design%2C%20placed%20on%20a%20clean%20cream%20surface%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20minimal%20aesthetic&width=800&height=800&seq=product-thermos-11&orientation=squarish',
    tags: ['联名', '限定', '热销'],
    isNew: true,
    isHot: true,
  },
  {
    id: 12,
    name: '黄油小熊收藏展示盒',
    slug: 'display-case',
    category: 'collectible',
    price: '¥99',
    description: '黄油小熊专属收藏展示盒，亚克力材质通透无痕，内置LED灯带可调节亮度。阶梯式展示台设计，能完美陈列你的黄油小熊盲盒和迷你手办。防尘设计让收藏品历久如新。',
    image: 'https://readdy.ai/api/search-image?query=An%20acrylic%20display%20case%20with%20built-in%20warm%20LED%20lighting%20for%20showcasing%20cute%20warm%20yellow%20butter%20bear%20figurines%20on%20tiered%20shelves%2C%20clean%20cream%20background%2C%20soft%20warm%20lighting%2C%20product%20photography%2C%20collector%20display%20style&width=800&height=800&seq=product-displaycase-12&orientation=squarish',
    tags: ['新品'],
    isNew: true,
    isHot: false,
  },
];

export const categoryMap: Record<string, string> = {
  plush: '毛绒玩偶',
  accessories: '精致配饰',
  home: '居家好物',
  stationery: '文具手账',
  collab: '联名限定',
  collectible: '收藏臻品',
};

export const categoryOrder = ['plush', 'accessories', 'home', 'stationery', 'collab', 'collectible'];